export default __webpack_public_path__ + "locales/es/Article.json?hash=22e99d0ac176f2476f79cf230dcbfa7e";